/**
 * REF-5796 (Option A) — iOS "tap-to-save" for 4K downloads.
 *
 * A 4K image is produced server-side and arrives asynchronously (WebSocket, or a network round-trip
 * for already-4K), long after the user's tap — so iOS's ~0.5s activation window is gone and no save
 * can fire. Instead of blindly failing, the delivery points dispatch this event; a global
 * `Ios4kDownloadPrompt` catches it, pre-fetches the finished image, and shows a Save button whose
 * tap is a fresh gesture → `navigator.share` (Save to Photos/Files).
 *
 * Plain module (no JSX/React) so the socket handler and download hooks can dispatch without pulling
 * the prompt component into their bundles or risking an import cycle.
 */

export const EVENT_IOS_4K_READY = "RefabricIos4kReady";

export interface Ios4kReadyDetail {
  /** URL of the finished 4K image (WS `image_url`, or the already-4K `download_url`). */
  resultUrl: string;
  /** Optional server-provided filename (extension used for the saved file). */
  fileName?: string;
}

/** Announce that a 4K image is ready to save (iOS only). The global prompt picks it up. */
export const dispatchIos4kReady = (detail: Ios4kReadyDetail): void => {
  window.dispatchEvent(new CustomEvent<Ios4kReadyDetail>(EVENT_IOS_4K_READY, { detail }));
};
